import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white-50 p-4" }
const _hoisted_2 = { class: "row mx-4" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "w-max-content col-lg-2 col-form-label fs-9 fw-bold" }
const _hoisted_5 = { class: "row mb-5" }
const _hoisted_6 = { class: "col-lg-8 col-form-label fs-7" }
const _hoisted_7 = { class: "row mb-4 border-bottom-search" }
const _hoisted_8 = { class: "w-max-content col-lg-2 fs-7" }
const _hoisted_9 = { class: "col-lg-9 d-flex flex-wrap" }
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = ["name", "id", "value"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "row mb-4 border-bottom-search" }
const _hoisted_14 = { class: "col-lg-2 fs-7" }
const _hoisted_15 = { class: "col-lg-10" }
const _hoisted_16 = { class: "form-check me-4 pe-4 col-md-1" }
const _hoisted_17 = ["for"]
const _hoisted_18 = ["name", "id", "value"]
const _hoisted_19 = {
  class: "fs-7",
  style: {"padding-top":"2px"}
}
const _hoisted_20 = {
  key: 0,
  class: "row mb-4 border-bottom-search"
}
const _hoisted_21 = { class: "col-lg-2 fs-7" }
const _hoisted_22 = { class: "col-lg-10" }
const _hoisted_23 = { class: "d-lg-flex mb-2" }
const _hoisted_24 = { class: "form-check me-4 pe-4" }
const _hoisted_25 = { class: "form-check-label fs-7" }
const _hoisted_26 = ["name", "value"]

import { computed, onMounted, ref, watch } from 'vue'
import { translate } from '@/languages/i18n'
import { COMMUNITY_ALUMNUS_STORE, CONVERSATIONS_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  resetDataDetail: {
    type: Boolean,
  },
  tabFlag: Boolean,
  filterForAlumni: {
    type: Boolean,
    default: false,
  },
},
  emits: ['formDetail'],
  setup(__props, { emit }) {

const props = __props

const dataSearchDetail = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.GET_DATA_SEARCH_DETAIL])



const store = useStore()
const route = useRoute()
const listFlags = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_MANAGING_FLAGS])
const FlagData = ref({
  managementFlag: [],
  searchConditions: 'and',
  conditionNotFlagData: false,
})

onMounted(() => {
  if (Object.keys(dataSearchDetail.value.flag).length > 0) {
    FlagData.value = dataSearchDetail.value.flag
  }
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_MANAGING_FLAGS, route.params?.id)
})

watch(
  () => props.resetDataDetail,
  () => {
    if (props.resetDataDetail) {
      FlagData.value.managementFlag = []
      FlagData.value.searchConditions = 'and'
      FlagData.value.conditionNotFlagData = false
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'flag', data: FlagData.value })
    }
  }
)

watch(
  () => props.tabFlag,
  () => {
    if (props.tabFlag) {
      objChanged()
    }
  }
)

const objChanged = () => {
  emit('formDetail', { ...FlagData.value, managementFlag: Object.values(FlagData.value.managementFlag) })
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'flag', data: FlagData.value })
}
const conditions = [
  {
    title: translate('OE10checkedAll'),
    value: 'and',
    content: 'AND',
  },
  {
    title: translate('OE10oneChecked'),
    value: 'or',
    content: 'OR',
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFlag && _ctx.submitFlag(...args)), ["prevent"])),
    class: "row align-items-center"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)(`OE10flagSearch`)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('OE10titleTab2')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('OE10managementFlag')), 1),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listFlags), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "mw-100 me-5",
                key: index
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input cursor-pointer fs-7",
                    type: "checkbox",
                    name: `flag-alumni${item?.name + item?.id}`,
                    id: `flag-alumni${item?.name + item?.id}`,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((FlagData.value.managementFlag) = $event)),
                    value: item?.id,
                    onChange: objChanged
                  }, null, 40, _hoisted_11), [
                    [_vModelCheckbox, FlagData.value.managementFlag]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label cursor-pointer text-break",
                    for: `flag-alumni${item?.name + item?.id}`
                  }, _toDisplayString(item?.name), 9, _hoisted_12)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(translate)('OE10searchConditions')), 1),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(conditions, (item, index) => {
              return _createElementVNode("div", {
                class: "d-lg-flex mb-2",
                key: index
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", {
                    class: "form-check-label fs-7",
                    for: item.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((FlagData.value.searchConditions) = $event)),
                      type: "radio",
                      name: item.value,
                      id: item.value,
                      value: item.value,
                      onChange: objChanged
                    }, null, 40, _hoisted_18), [
                      [_vModelRadio, FlagData.value.searchConditions]
                    ]),
                    _createTextVNode(" " + _toDisplayString(item.content), 1)
                  ], 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_19, _toDisplayString(item.title), 1)
              ])
            }), 64))
          ])
        ]),
        (__props.filterForAlumni)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(translate)('OE10excludeSelection')), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((FlagData.value.conditionNotFlagData) = $event)),
                        type: "checkbox",
                        name: _unref(translate)('OE10excludeUserConditions'),
                        id: "excl",
                        value: _unref(translate)('OE10excludeUserConditions'),
                        onChange: objChanged
                      }, null, 40, _hoisted_26), [
                        [_vModelCheckbox, FlagData.value.conditionNotFlagData]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('OE10excludeUserConditions')), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 32))
}
}

})